import { API_BASE_URL } from './index';
import { callApi } from 'utils/callApi';

// eslint-disable-next-line import/prefer-default-export

export const addTestimonialRequest = ({ studentCommentTo, comment, reqTestimonialId }) =>
    callApi({
        requestFunction: (axios) =>
            axios.post(`${API_BASE_URL}/web/users/testimonials/add`, {
                studentCommentTo,
                comment,
                reqTestimonialId
            }),
        successCode: 200
    });

export const getTestimonialRequest = () =>
    callApi({
        requestFunction: (axios) => axios.get(`${API_BASE_URL}/web/users/testimonials`),
        successCode: 200,
        showToastOnError: false,
        showToastOnSuccess: false
    });

export const orderTestimonialRequest = (data) =>
    callApi({
        requestFunction: (axios) => axios.post(`${API_BASE_URL}/web/users/testimonials/order`, { testimonials: data }),
        successCode: 200,
        showToastOnError: false,
        showToastOnSuccess: false
    });

export const deleteTestimonialRequest = (testimonialId) =>
    callApi({
        requestFunction: (axios) => axios.delete(`${API_BASE_URL}/web/users/testimonials/${testimonialId}`),
        successCode: 200,
        showToastOnSuccess: true,
        showToastOnError: true
    });
